export default __webpack_public_path__ + "static/media/Modello domande quiz.8deabdeb.xlsx";